import {
  Box,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  VStack,
  TabList,
  Tab,
  TabPanel,
  TabPanels,
  Tabs,
  Button,
  Text,
  HStack,
  Icon,
  Badge,
  useToast,
  useColorModeValue,
} from '@chakra-ui/react';
import { Carrier as CarrierItem, useGetCarriersQuery } from 'src/utils/__generated__/graphql';
import { CarrierListItem, PageHeader, ModernCard, LoadingSpinner } from './shared';
import { useNavigate } from 'react-router-dom';
import CarrierSearchDropdown from './shared/CarrierSearchDropdown';
import { FiTruck, FiPlus } from 'react-icons/fi';
import { ElementType } from 'react';

export const Carrier = () => {
  const navigate = useNavigate();
  const toast = useToast();
  const { data, error, loading } = useGetCarriersQuery();

  console.log(data?.carrier);

  if (loading) return <LoadingSpinner text="Loading carriers..." />;
  if (error) {
    toast({
      title: 'Error',
      description: error.message,
      status: 'error',
      duration: 5000,
      isClosable: true,
    });
    return (
      <ModernCard p={8}>
        <VStack spacing={4} textAlign="center">
          <Text fontSize="lg" fontWeight="semibold" color="red.500">
            Error Loading Carriers
          </Text>
          <Text color="gray.600">{error.message}</Text>
        </VStack>
      </ModernCard>
    );
  }

  return (
    <>
      <PageHeader
        title="Carrier Management"
        subtitle="Manage delivery carriers and their information"
        badge={
          <Badge colorScheme="brand" fontSize="sm" borderRadius="full" px={3} py={1}>
            {data?.carrier?.length || 0} Carriers
          </Badge>
        }
        actions={
          <Button
            leftIcon={<Icon as={FiPlus as ElementType} />}
            colorScheme="brand"
            size={{ base: 'md', md: 'lg' }}
            onClick={() => navigate('new')}
            _hover={{ transform: 'translateY(-1px)', boxShadow: 'md' }}
          >
            <Text display={{ base: 'none', sm: 'block' }}>Add New Carrier</Text>
            <Text display={{ base: 'block', sm: 'none' }}>Add Carrier</Text>
          </Button>
        }
      />

      <Tabs size={{ base: 'sm', md: 'md' }} variant="soft-rounded" colorScheme="brand" p={{ base: 4, md: 6 }}>
        <Box
          borderRadius="xl"
          overflow="hidden"
          backgroundColor={useColorModeValue('white', 'gray.800')}
          shadow="sm"
          pt={6}
          px={4}
          alignItems="center"
          display="flex"
        >
          <TabList mb={{ base: 4, md: 6 }}>
            <Tab
              _selected={{ color: 'white', bg: 'brand.500' }}
              fontWeight="medium"
              fontSize={{ base: 'sm', md: 'md' }}
            >
              <HStack spacing={2}>
                <Icon as={FiTruck as ElementType} boxSize={{ base: 4, md: 5 }} />
                <Text>Carriers</Text>
              </HStack>
            </Tab>
          </TabList>
        </Box>
        <TabPanels>
          <TabPanel px={0}>
            <VStack spacing={4} align="stretch">
              <CarrierSearchDropdown />
              <Box
                overflowX="auto"
                borderRadius="md"
                backgroundColor={useColorModeValue('white', 'gray.800')}
                shadow="sm"
                p={4}
              >
                <Table variant="simple" size={{ base: 'sm', md: 'md' }}>
                  <Thead>
                    <Tr>
                      <Th display={{ base: 'none', md: 'table-cell' }}>Image</Th>
                      <Th>Name</Th>
                      <Th display={{ base: 'none', md: 'table-cell' }}>Phone</Th>
                      <Th display={{ base: 'none', md: 'table-cell' }}>Active</Th>
                      <Th>Actions</Th>
                    </Tr>
                  </Thead>
                  <Tbody>
                    {data?.carrier?.length === 0 ? (
                      <Tr>
                        <Td colSpan={5}>
                          <VStack spacing={4} py={8} textAlign="center">
                            <Icon as={FiTruck as ElementType} boxSize={12} color="gray.400" opacity={0.5} />
                            <Text fontSize="lg" fontWeight="semibold" color="gray.600">
                              No Carriers Found
                            </Text>
                            <Text color="gray.500">Start by adding your first carrier to the platform.</Text>
                          </VStack>
                        </Td>
                      </Tr>
                    ) : (
                      data?.carrier.map((carrier, index: number) => (
                        <CarrierListItem key={index} carrier={carrier as CarrierItem} />
                      ))
                    )}
                  </Tbody>
                </Table>
              </Box>
            </VStack>
          </TabPanel>
        </TabPanels>
      </Tabs>
    </>
  );
};
